import { render, staticRenderFns } from "./userAccountFlow.vue?vue&type=template&id=54c45b10"
import script from "./userAccountFlow.vue?vue&type=script&lang=js"
export * from "./userAccountFlow.vue?vue&type=script&lang=js"
import style0 from "./userAccountFlow.vue?vue&type=style&index=0&id=54c45b10&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports